import React from "react";
import { Sparkles } from "lucide-react";

const SUGGESTED_PROMPTS = [
  "Help me write an email",
  "Summarize a document",
  "Brainstorm ideas",
  "Draft a meeting agenda",
];

interface ChatWelcomeProps {
  onSelectPrompt: (prompt: string) => void;
}

export const ChatWelcome: React.FC<ChatWelcomeProps> = ({ onSelectPrompt }) => (
  <div className="chat-welcome">
    <Sparkles size={32} style={{ color: "var(--brand-badge-bg)" }} />
    <div>
      <h3 style={{ fontSize: 16, fontWeight: 600, color: "var(--text-primary)" }}>
        AI Assistant
      </h3>
      <p style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 4 }}>
        Ask me anything — writing, brainstorming, summarizing, and more.
      </p>
    </div>
    <div className="chat-welcome-chips">
      {SUGGESTED_PROMPTS.map((prompt) => (
        <button
          key={prompt}
          className="chat-welcome-chip"
          onClick={() => onSelectPrompt(prompt)}
        >
          {prompt}
        </button>
      ))}
    </div>
  </div>
);
